import { render, staticRenderFns } from "./ImagPreview.vue?vue&type=template&id=861a5a9a&scoped=true&"
import script from "./ImagPreview.vue?vue&type=script&lang=js&"
export * from "./ImagPreview.vue?vue&type=script&lang=js&"
import style0 from "./ImagPreview.vue?vue&type=style&index=0&id=861a5a9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861a5a9a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('861a5a9a')) {
      api.createRecord('861a5a9a', component.options)
    } else {
      api.reload('861a5a9a', component.options)
    }
    module.hot.accept("./ImagPreview.vue?vue&type=template&id=861a5a9a&scoped=true&", function () {
      api.rerender('861a5a9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/jeecg/ImagPreview.vue"
export default component.exports